import { call, put, takeEvery } from 'redux-saga/effects';
import { setLeadStatus } from '../../requests/change_leads_status_request';
import { getSrSyncStatus } from '../../requests/get_sr_sync_status_request';
import { getLeadProfile } from '../../requests/get_lead_profile_request';
import {
    changeLeadsStatusRequestFailure,
    changeLeadsStatusRequestSuccess,
} from '../actions/change_lead_status.actions';
import { getLeadProfileRequestFailure } from '../actions/get_lead_profile.actions';
import { CHANGE_LEADS_STATUS_REQUEST } from '../constants/leads_status.constants';
import { message_success, message_error } from '../../../../../components/Message';
import { changeLeadPot } from '../actions/get_lead_profile_with_refs.actions';
import { LEAD_STATUS, LEAD_CANCELLATION_STATUSES } from '../../../constants/leadStatuses';
import { SET_LEAD_VALUATIONS_REDUCER } from '../constants/get_lead_profile.constants';
import { getErrorMessage } from '../../../../../shared/helpers';

function* changeLeadStatusRequest({ _id, status_id, requestParams = {} }) {
    // Check isSRSyncInProgress before cancellation
    if (LEAD_CANCELLATION_STATUSES.includes(status_id)) {
        try {
            const { result, options, error } = yield call(getSrSyncStatus);
            const isSyncFinished = result && options?.isSRSyncInProgress === "false";

            if (error) {
                const errorMessage = getErrorMessage(error);

                message_error(`Failed to get SR sync status. ${errorMessage}, please try to change status lead status later`);
                yield put(changeLeadsStatusRequestFailure(errorMessage));
                return;
            }

            if (!isSyncFinished) {
                message_error('Smart routes sync currently in progress, please try to change status lead status later');
                yield put(changeLeadsStatusRequestFailure('Smart routes sync currently in progress, please try to change status lead status later'));
                return;
            }
        } catch (err) {
            const errorMessage = getErrorMessage(err);

            message_error(`${errorMessage}, please try to change status lead status later`);
            yield put(changeLeadsStatusRequestFailure(errorMessage));
            return;
        }
    }

    const changed_status = yield call(setLeadStatus, _id, status_id, requestParams);
    if (changed_status.result) {
        if (requestParams.onSuccess) {
            yield requestParams.onSuccess();
        }
        const { result, options, error } = yield call(getLeadProfile, _id);

        if (result) {
            yield put(changeLeadsStatusRequestSuccess(options));

            // To update lead_pot after changing status to update profile page
            yield put(changeLeadPot(options.lead_pot));
            // To update lead valuations after changing status to Pending (Trade)
            if (status_id === LEAD_STATUS.pendingTrade) {
                yield put({ type: SET_LEAD_VALUATIONS_REDUCER, payload: options.valuations });
            }
        } else {
            yield put(getLeadProfileRequestFailure(error));
        }
        message_success('Lead status changed successfully!');
    } else {
        yield put(changeLeadsStatusRequestFailure(changed_status.error));
        message_error('You cannot set this status!');
    }
}

export default function* changeLeadStatusSaga() {
    yield takeEvery(CHANGE_LEADS_STATUS_REQUEST, changeLeadStatusRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/change_lead_status.saga.js